export const getUserPaymentMethod = (state) => state.payment.userPaymentDetails?.paymentDetails?.paymentMethod;
